/// <amd-module name="ClemtexPay.PayHosted"/>
//
// Entry point — registers the /pay/:slug page type with the SuiteCommerce
// PageType component. Customer hits clemtex.com/pay/aB3xK9pq → SC's Backbone
// router matches the 'pay/:slug' pattern → instantiates PayHostedView →
// renders the payment template.
//
// Phase 1 (this commit): View just shows a placeholder with the slug from
// the URL. No service call, no Stripe form.
//
// Phase 2: View will call ClemtexPay.PayHosted.Service.ss to verify the slug
// (HMAC server-side) and fetch record context, then render the real Stripe
// Payment Element.
//
define(
    'ClemtexPay.PayHosted',
    [
        'ClemtexPay.LoginHook',
        'ClemtexPay.PayHosted.View'
    ],
    function (LoginHook, PayHostedViewModule) {
        'use strict';

        return {
            mountToApp: function (container) {
                LoginHook.install(); // pre-login 'Pay by Link' terms flip (Web Checkout)
                var pageTypeComponent = container.getComponent('PageType');
                pageTypeComponent.registerPageType({
                    name: 'ext-clemtex-pay',
                    routes: [
                        'pay/:slug',
                        'pay(/)'
                    ],
                    view: PayHostedViewModule.PayHostedView
                });
            }
        };
    }
);
